import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    getMaxIdFromStorage,
    getMaxIdFromUrl,
    useMessenger,
} from '../context/messengerContext';
import './AppBackButton.css';
import { useLocation } from 'react-router-dom';

/**
 * Универсальная кнопка "Назад":
 * - telegram / max: показывает нативную кнопку через showBackButton, в DOM ничего не рендерит.
 * - web: рендерит UI-кнопку со стрелкой влево.
 */

const HIDE_BACK_ROUTES_PATHS = ['/', '/menu', '/auth', '/auth_contact', '/install'];

export default function AppBackButton() {
    const { t } = useTranslation('basic');
    const location = useLocation();
    const pathname = location.pathname || '';

    const { platform, showBackButton, hideBackButton, navigate } =
        useMessenger();

    const shouldHide = HIDE_BACK_ROUTES_PATHS.some(
        (p) => pathname === p || pathname.startsWith(p + '/'),
    );

    const onNavigate = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const fromChatQuery = urlParams.has('fromChat');


        if (fromChatQuery) {
            navigate('/menu');
            return;
        }
        navigate(-1);
    };

    useEffect(() => {
        if (platform === 'web') return;

        // На «главных» маршрутах (/, /menu, /auth) нативную кнопку не показываем —
        // иначе в TG/Max она видна на /menu и путает навигацию.
        if (shouldHide) {
            hideBackButton();
            return;
        }

        showBackButton(() => onNavigate());
        return () => hideBackButton();
    }, [platform, showBackButton, hideBackButton, navigate, shouldHide]);

    if (
        shouldHide ||
        window.Telegram?.WebApp?.initData ||
        window.TelegramWebviewProxy ||
        window.WebApp?.initData
    )
        return null;

    // MAX-пользователь, открывший PWA из браузера — SDK нет
    if (getMaxIdFromUrl() || getMaxIdFromStorage())
        return (
            <button
                type='button'
                className='app-back-button'
                onClick={() => onNavigate()}
                aria-label={t('back')}
            >
                ←
            </button>
        );

    return (
        <button
            type='button'
            className='app-back-button'
            onClick={() => onNavigate()}
            aria-label={t('back')}
        >
            ←
        </button>
    );
}
